export enum PartnerType {
  SPONSOR = 'SPONSOR',
  BROKER = 'BROKER',
  CRO = 'CRO',
}
